// 500 => 500,00
export const formatMoney = (hours: number) => hours ? hours.toFixed(2).replace('.', ',') : '0,00'

// 100,00 => 100
export const converteStringToNumber = (value: string): number =>  value ? Number(value.replace(',','.')) : 0

